import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.registration_request');

    core.constant(
        'REGISTRATION_REQUEST',
        Object.freeze({
            registration_request: {
                status:[
                    { value: 'PENDING', label: 'registration_request.status.pending' },
                    { value: 'VALIDATED', label: 'registration_request.status.validated' },
                    { value: 'REFUSED', label: 'registration_request.status.refused' },

                ],
                pagination: {
                    defaultPageSize: 20,
                    defaultSort: [
                        {
                            direction: 'DESC',
                            property: 'creationDate',
                        },
                        {
                            direction: 'ASC',
                            property: 'companyName',
                        },
                    ],
                    defaultPage: 0,
                },
                columnFieldMap: [
                    {
                        field: 'creationDate',
                        property: 'creationDate',
                    },
                    {
                        field: 'getNameForList()',
                        property: 'companyName',
                    },
                    {
                        field: 'userLastName',
                        property: 'lastname',
                    },
                    {
                        field: 'userFisrtName',
                        property: 'firstname',
                    },
                    {
                        field: 'userEmail',
                        property: 'email',
                    },
                    {
                        field: 'status',
                        property: 'status',
                    },
                 
                ],
            }
        })
    );
})();
